export default __webpack_public_path__ + "static/media/gp-play-full.2292ed3a.svg";